import { IContractAgreementMutation, IContractSectionMutation } from 'services/contract/types';
import {
  AGREEMENT_TYPE,
  IAgreementTemplatetAggregatorForm,
} from 'services/templates/agreement-template/types';
import { CUSTOM_SECTION_TYPE } from 'services/templates/section-template/types';
import {
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';

const hasSectionContent = (section: IContractSectionMutation) =>
  section.agreements.length > 0 || section.subsections.length > 0;

const mapContractSectionChildren = (
  children: IContractTemplateTreeItemForm[]
): Pick<IContractSectionMutation, 'agreements' | 'subsections'> => {
  const agreements: IContractAgreementMutation[] = [];
  const subsections: IContractSectionMutation[] = [];
  let position = 0;

  for (const child of children) {
    if (child.type === TEMPLATE_TYPE.agreement) {
      const content = child.content as IAgreementTemplatetAggregatorForm;
      const isParagraph = content.type === AGREEMENT_TYPE.paragraph;
      const agreementContent = isParagraph
        ? content.paragraphAgreementTemplate
        : content.textAgreementTemplate;

      agreements.push({
        textAgreementRequest: {
          position,
          title: agreementContent?.title ?? '',
          defaultValue: agreementContent?.defaultValue ?? '',
        },
      });
      position += 1;
      continue;
    }

    if (child.type === TEMPLATE_TYPE.section) {
      const mapped = mapContractSectionTreeItem(
        child as IContractTemplateTreeItemForm & { content: string },
        CUSTOM_SECTION_TYPE.Text,
        position
      );

      if (hasSectionContent(mapped)) {
        subsections.push(mapped);
        position += 1;
      }
    }
  }

  return { agreements, subsections };
};

const mapContractSectionTreeItem = (
  item: IContractTemplateTreeItemForm & { content: string },
  type: CUSTOM_SECTION_TYPE,
  position: number
): IContractSectionMutation => ({
  title: item.content,
  position,
  type,
  ...mapContractSectionChildren(item.children),
});

export const mapContractSectionsFromItems = (
  items: IContractTemplateTreeItemForm[]
): IContractSectionMutation[] => {
  const sections: IContractSectionMutation[] = [];

  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];

    if (
      item.type !== TEMPLATE_TYPE.section &&
      item.type !== TEMPLATE_TYPE.paragraphSection
    ) {
      continue;
    }

    sections.push(
      mapContractSectionTreeItem(
        item as IContractTemplateTreeItemForm & { content: string },
        item.type === TEMPLATE_TYPE.paragraphSection
          ? CUSTOM_SECTION_TYPE.Paragraph
          : CUSTOM_SECTION_TYPE.Text,
        index
      )
    );
  }

  return sections;
};
